import React from 'react'

export default function NavBarItem( {name, icon, state}) {
    return (
        <li className={`nav-item iris-navitem ${state}`}>
            <a className="nav-link" href="..">
                  <span className="nav-link-icon d-md-none d-lg-inline-block">{icon}</span>
                <span className="nav-link-title"> {name} </span>
            </a>
        </li>
    )
}
